export const LIST_SALES_ORDER = 'LIST_SALES_ORDER'
